import type { ModuleCard } from "./documentationOverviewContent";

type AccentClasses = {
  iconBg: string;
  iconText: string;
  ring: string;
  badge: string;
};

export const ACCENT_STYLES: Record<ModuleCard["accent"], AccentClasses> = {
  blue: {
    iconBg: "bg-blue-50",
    iconText: "text-blue-600",
    ring: "group-hover:ring-blue-200",
    badge: "bg-blue-50 text-blue-700",
  },
  emerald: {
    iconBg: "bg-emerald-50",
    iconText: "text-emerald-600",
    ring: "group-hover:ring-emerald-200",
    badge: "bg-emerald-50 text-emerald-700",
  },
  amber: {
    iconBg: "bg-amber-50",
    iconText: "text-amber-600",
    ring: "group-hover:ring-amber-200",
    badge: "bg-amber-50 text-amber-700",
  },
  violet: {
    iconBg: "bg-violet-50",
    iconText: "text-violet-600",
    ring: "group-hover:ring-violet-200",
    badge: "bg-violet-50 text-violet-700",
  },
  rose: {
    iconBg: "bg-rose-50",
    iconText: "text-rose-600",
    ring: "group-hover:ring-rose-200",
    badge: "bg-rose-50 text-rose-700",
  },
  slate: {
    iconBg: "bg-slate-100",
    iconText: "text-slate-700",
    ring: "group-hover:ring-slate-200",
    badge: "bg-slate-100 text-slate-700",
  },
};

export const SECTION_SPACING = "mt-12";
export const SECTION_EYEBROW =
  "text-xs font-semibold uppercase tracking-[0.14em] text-primary mb-2";
export const SECTION_TITLE = "text-2xl font-bold text-slate-900 font-heading";
export const SECTION_SUBTITLE = "text-sm text-slate-600 mt-1 max-w-2xl";

export const TRANSITION_HOVER =
  "transition-all duration-300 ease-out hover:-translate-y-0.5 hover:shadow-md";
